import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/components/AccountsPage/AccountsPage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/components/MobileApp/AccountsPageMobile/AccountsPageMobile.jsx");
